import React from "react";
import { Col, Space } from "antd";

import OrderList from "../../components/OrderList";

function OrderManagement() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 style={{ fontSize: "24px", fontWeight: "bold", margin: "0 0 16px 0" }}>주문 현황</h3>
                <OrderList />
            </Space>
        </div>
    );
}

export default OrderManagement;
